import React, {useContext} from 'react';
// import Footer from '../pageComponents/Footer';
import Navigation from '../pageComponents/Navigation';
import Header from '../pageComponents/Header';
import './ContactPage.scss';
import { LanguageContext } from "../language/LanguageContext";

const ContactPage = () => {
     const { userLanguage } = useContext(LanguageContext);

    return (
        <>
        <Header />
        <Navigation/>
        <div className='contact-holder main'>

                {userLanguage === 'de' ? (<>

                <h1>Atelier Hartmut Piniek</h1>

                <table   border="0">
                <tbody><tr><td >Straße der Freundschaft 11, 04571 Oelzschau</td></tr>
                <tr><td >E-Mail: <a href="mailto:atelier_hp@gmx.de">atelier_hp@gmx.de</a></td></tr>
                </tbody></table>

              <br></br>
              <br></br>
              <br></br>

                <h1>Lieferbare Kataloge</h1>

                <table   border="0">
                <tbody><tr><td >H.P.</td></tr>
                <tr><td> 2020</td></tr>
                <tr><td >71 Abbildungen, 100 Seiten, Abmessungen 26x23x0,9 cm, Softcover</td></tr>
                <tr><td >mit Texten von H. Stecker, H. Zitko, A. Piniek</td></tr>
                <tr><td >Preis 20 €, inkl. Versand</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >Hartmut Piniek</td></tr>
                 <tr><td>2000</td></tr>
                <tr><td >46 Abbildungen, 57 Blätter, Abmessungen 26x23x0,9 cm, Softcover</td></tr>
                <tr><td >mit Texten von B. Roggow, H. Zitko, T. Sommer</td></tr>
                <tr><td >Preis 18 €, inkl. Versand</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >Sehnsucht, Reisebilder</td></tr>
                <tr><td>2021</td></tr>
                <tr><td >42 Abbildungen, 52 Seiten, Abmessungen 21x21x0,5 cm, Softcover</td></tr>
                <tr><td >mit Texten von A. Piniek und Reisenotizen von H. Piniek</td></tr>
                <tr><td >Preis 15 €, inkl. Versand</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >HP</td></tr>
                <tr><td>1996</td></tr>
                <tr><td >10 Abbildungen, 18 Blätter, Abmessungen 14,8x21x0,2 cm, Softcover</td></tr>
                <tr><td >mit Text von H. Zitko </td></tr>
                <tr><td >Preis 10 €, inkl. Versand</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >Kleine Arbeiten</td></tr>
                <tr><td>2014</td></tr>
                <tr><td >11 Abbildungen, 10 Seiten, Abmessungen 22x21x0,4 cm, Klammerheftung</td></tr>
                <tr><td >mit Texten von S. Tippach-Schneider, I. Piniek</td></tr>
                <tr><td >Preis 6 €, inkl. Versand</td></tr>
                </tbody></table>

                <br></br>
                <br></br>
                <br></br>
                

                <h1>Haftungshinweis</h1>

 <p>

    
Alle Rechte vorbehalten. Das Copyright für Veröffentlichungen auf dieser Webseite bleibt vorbehalten. Eine Vervielfältigung oder Verwendung der Bilder und Texte ist ohne die schriftliche Genehmigung von Hartmut Piniek nicht gestattet.
Hartmut Piniek ist nicht verantwortlich für direkte oder indirekte Verweise auf fremde Webseiten. Die Inhalte werden nicht geprüft und unterliegen der Kontrolle und Haftung der Anbieter.
Die Nutzung von veröffentlichten Kontaktdaten, wie Postanschriften, Telefonnummern und Emailadressen durch Dritte ist nicht für Werbezwecke gestattet.

<br></br>
<br></br>


Der Anbieter dieser Website nutzt Dienste der etracker GmbH aus Hamburg, Deutschland zur Analyse von Nutzungsdaten. Wir verwenden standardmäßig keine Cookies für die Web-Analyse. Soweit wir Analyse- und Optimierungs-Cookies einsetzen, holen wir Ihre explizite Einwilligung gesondert im Vorfeld ein. Ist das der Fall und Sie stimmen zu, werden Cookies eingesetzt, die eine statistische Reichweiten-Analyse dieser Website, eine Erfolgsmessung unserer Online-Marketing-Maßnahmen sowie Testverfahren ermöglichen, um z.B. unterschiedliche Versionen unseres Online-Angebotes oder seiner Bestandteile zu testen und zu optimieren. Cookies sind kleine Textdateien, die vom Internet Browser auf dem Endgerät des Nutzers gespeichert werden. etracker Cookies enthalten keine Informationen, die eine Identifikation eines Nutzers ermöglichen.
Die mit etracker erzeugten Daten werden im Auftrag des Anbieters dieser Website von etracker ausschließlich in Deutschland verarbeitet und gespeichert und unterliegen damit den strengen deutschen und europäischen Datenschutzgesetzen und -standards. etracker wurde diesbezüglich unabhängig geprüft, zertifiziert und mit dem Datenschutz-Gütesiegel ePrivacyseal ausgezeichnet.
Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des Art. 6 Abs. 1 lit. f (berechtigtes Interesse) der Datenschutzgrundverordnung (DSGVO). Unser Anliegen im Sinne der DSGVO (berechtigtes Interesse) ist die Optimierung unseres Online-Angebotes und unseres Webauftritts. Da uns die Privatsphäre unserer Besucher wichtig ist, werden die Daten, die möglicherweise einen Bezug zu einer einzelnen Person zulassen, wie die IP-Adresse, Anmelde- oder Gerätekennungen, frühestmöglich anonymisiert oder pseudonymisiert. Eine andere Verwendung, Zusammenführung mit anderen Daten oder eine Weitergabe an Dritte erfolgt nicht.
Sie können der vorbeschriebenen Datenverarbeitung jederzeit widersprechen. Der Widerspruch hat keine nachteiligen Folgen. Weitere Informationen zum Datenschutz bei etracker finden Sie unter www.etracker.com/datenschutz/.


</p>

<br></br>
<br></br>
<br></br>
                
<h1>Webgestaltung</h1>

<p> Igor Piniek, Tobias Henning
</p>



                </>
                ) : (
                    <>

                <h1>Studio Hartmut Piniek</h1>

                <table   border="0">
                <tbody><tr><td >Straße der Freundschaft 11, 04571 Oelzschau</td></tr>
                <tr><td >E-Mail: <a href="mailto:atelier_hp@gmx.de">atelier_hp@gmx.de</a></td></tr>
                </tbody></table>

                <br></br>
                <br></br>
                <br></br>

                <h1>Available catalogues</h1>

                <table   border="0">
                <tbody><tr><td >H.P.</td></tr>
                <tr><td>2020</td></tr>
                <tr><td >71 pictures, 100 pages, dimensions 26x23x0,9 cm, Softcover</td></tr>
                <tr><td >with texts by H. Stecker, H. Zitko, A. Piniek</td></tr>
                <tr><td >Price 20 € + shipping cost</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >Hartmut Piniek</td></tr>
                <tr><td>2000</td></tr>
                <tr><td >46 pictures, 57 sheets, dimensions 26x23x0,9 cm, Softcover</td></tr>
                <tr><td >with texts by B. Roggow, H. Zitko, T. Sommer</td></tr>
                <tr><td >Price 18 € + shipping cost</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >Sehnsucht, Reisebilder</td></tr>
                <tr><td>2021</td></tr>
                <tr><td >42 pictures, 52 pages, dimensions 21x21x0,5 cm, Softcover</td></tr>
                <tr><td >with texts by A. Piniek and travel notes by H. Piniek</td></tr>
                <tr><td >Price 15 € + shipping cost</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >HP</td></tr>
                <tr><td>1996</td></tr>
                <tr><td >110 pictures, 18 sheets, dimensios 14,8x21x0,2 cm, Softcover</td></tr>
                <tr><td >with texts by H. Zitko </td></tr>
                <tr><td >Price 10 € + shipping cost</td></tr>
                </tbody></table>

                <table   border="0">
                <tbody><tr><td >small pictures</td></tr>
                <tr><td>2014</td></tr>
                <tr><td >11 pictures, 10 pages, dimensions 22x21x0,4 cm, clampstapling</td></tr>
                <tr><td >with texts by S. Tippach-Schneider, I. Piniek</td></tr>
                <tr><td >Price 6 € + shipping cost</td></tr>
                </tbody></table>

                <br></br>
                <br></br>
                <br></br>
                

                <h1>Copyright</h1>

                <p>

    
                All rights reserved. Copyright for publications on this website remains reserved. Reproduction or use of the images and texts is not permitted without the written consent of Hartmut Piniek.
                Hartmut Piniek is not responsible for direct or indirect links to external websites. The content of these external sites is not reviewed and is subject to the control and liability of the respective providers.
                The use of published contact information, such as postal addresses, telephone numbers, and email addresses, by third parties for advertising purposes is not permitted.


                <br></br>
                <br></br>  


                The provider of this website uses services from etracker GmbH, Hamburg, Germany, to analyze usage data. We do not use cookies for web analytics by default. If we use analytics and optimization cookies, we will obtain your explicit consent separately beforehand. If this is the case and you agree, cookies will be used that enable statistical reach analysis of this website, performance measurement of our online marketing activities, and testing procedures to, for example, test and optimize different versions of our online offering or its components. Cookies are small text files that are stored on the user's device by the internet browser. etracker cookies do not contain any information that allows for the identification of a user.
                The data generated by etracker is processed and stored by etracker exclusively in Germany on behalf of the provider of this website and is therefore subject to strict German and European data protection laws and standards. etracker has been independently audited and certified in this regard and has been awarded the ePrivacyseal data protection seal of approval.
                Data processing is carried out on the basis of the legal provisions of Article 6 Paragraph 1 Letter f (legitimate interest) of the General Data Protection Regulation (GDPR). Our legitimate interest within the meaning of the GDPR is the optimization of our online services and our website. Because the privacy of our visitors is important to us, data that could potentially identify an individual, such as IP addresses, login credentials, or device identifiers, is anonymized or pseudonymized as soon as possible. This data will not be used for any other purpose, combined with other data, or shared with third parties.
                You can object to the aforementioned data processing at any time. Such objection will not have any negative consequences. Further information on data protection at etracker can be found at www.etracker.com/datenschutz/.


                </p>

                <br></br>
                <br></br>
                <br></br>


                
                <h1>Web design</h1>

                <p> Igor Piniek, Tobias Henning
                </p>


                    </>
                )}  
            
           
           </div>
        {/* <Footer /> */}
    </>
    );
};

export default ContactPage;